

























































import { Component, Vue } from 'vue-property-decorator'
import { QueryFinanceWealthWayDailyCategoryGroup } from '@/api'
import { DateFormat2 } from '@/utils/date/DateUtil'

interface WayItem {
  wayType: number
  wayTypeName: string
  inQty: number
  outQty: number
  netQty: number
  txCount: number
  assetType: number
  statDate: string
}

interface CategoryGroup {
  categoryCode: string
  categoryName: string
  inQty: number
  outQty: number
  netQty: number
  txCount: number
  items: WayItem[]
}

function yesterdayStr(): string {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

@Component
export default class FinanceWealthWayCategoryList extends Vue {
  private statDate = yesterdayStr()
  private assetType = 1
  private loading = false
  private groups: CategoryGroup[] = []
  private activeNames: string[] = []

  private get pageTitle(): string {
    return this.assetType === 2 ? '积分流水大类归类明细' : '绿豆流水大类归类明细'
  }

  private get summary(): { inQty: number; outQty: number; netQty: number; itemCount: number } | null {
    if (this.groups.length === 0) return null
    let inQty = 0
    let outQty = 0
    let netQty = 0
    let itemCount = 0
    this.groups.forEach(g => {
      inQty += Number(g.inQty) || 0
      outQty += Number(g.outQty) || 0
      netQty += Number(g.netQty) || 0
      itemCount += g.items ? g.items.length : 0
    })
    return { inQty, outQty, netQty, itemCount }
  }

  public created() {
    if (this.$route.query.statDate) {
      this.statDate = String(this.$route.query.statDate)
    }
    if (this.$route.query.assetType) {
      this.assetType = Number(this.$route.query.assetType)
    }
    this.loadData()
  }

  public async loadData() {
    if (!this.statDate) {
      this.$message.warning('请选择统计日期')
      return
    }
    this.loading = true
    try {
      const list = await QueryFinanceWealthWayDailyCategoryGroup({
        statDate: this.statDate,
        assetType: this.assetType,
      })
      this.groups = list || []
      this.activeNames = this.groups.map(g => g.categoryCode)
    } finally {
      this.loading = false
    }
  }

  private drill(row: WayItem) {
    const day = DateFormat2(row.statDate || this.statDate)
    if (this.assetType === 2) {
      this.$router.push({ path: '/userPointsRecordList', query: { finishTime: day, wayType: String(row.wayType) } })
    } else {
      this.$router.push({ path: '/userWealthRecordList', query: { finishTime: day, type: '3', wayType: String(row.wayType) } })
    }
  }

  private goFlatList() {
    this.$router.push({
      path: '/statistical/financeWealthWayDailyList',
      query: { assetType: String(this.assetType) },
    })
  }

  private rowClassName({ row }: { row: WayItem }) {
    const net = Number(row.netQty) || 0
    const inQty = Number(row.inQty) || 0
    const outQty = Number(row.outQty) || 0
    const tx = Number(row.txCount) || 0
    if (net === 0 && inQty === 0 && outQty === 0 && tx === 0) {
      return 'zero-row'
    }
    return ''
  }
}
